import AppConfig from "@storyboards/appConfig";

angular
  .module("acl.common.config", [])
  .constant("AppConfig", AppConfig)
  .run(($location, HighbondNavigationService) => {
    // Initialize locale from URL parameter first
    let locale = $location.search()["locale"];

    // Set initial language immediately to prevent flicker
    const initialLanguage = locale || "en";
    AppConfig.language = initialLanguage;
    document.documentElement.setAttribute("lang", initialLanguage);

    // Try async initialization for navigation props
    // Both Angular and TypeScript services support async initialization.
    // The TypeScript service removes the deprecated sync method (jQuery AJAX).
    const initializeNavigation = async () => {
      try {
        // Use async method (works with both implementations)
        const data = await HighbondNavigationService.getGlobalNavProps();
        AppConfig.highbondNavBarProps = data;

        // Determine final language: URL param takes priority, then API response, then default
        const finalLanguage = locale || data.locale || "en";

        // Only update if language has changed to avoid unnecessary DOM updates
        if (AppConfig.language !== finalLanguage) {
          AppConfig.language = finalLanguage;
          document.documentElement.setAttribute("lang", finalLanguage);
        }
      } catch (error) {
        console.warn("⚠️ Failed to load navigation props, using defaults:", error);
        // Language already set to initial value, no update needed
      }
    };

    // Start async initialization (non-blocking)
    initializeNavigation();
  });
